import React from 'react';

import { CircularProgress } from '@mui/material';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import UsersTable from './UsersTable';
import Error500 from '../../../pages/Error500';
import AdminUsersContainer from '../AdminUsersContainer';

const StyledPanelContainer = styled.div`
    margin-bottom: 28px;
`;

const UsersAdmin: React.FC = () => {
    const { usersFetchStatus, usersFetchError } = useContainer(AdminUsersContainer);

    const renderUsersAdminPanel = () => {
        switch (usersFetchStatus) {
            case 'INITIAL':
            case 'LOADING':
                return <CircularProgress />;
            case 'SUCCESS':
                return <UsersTable />;
            case 'ERROR':
            default:
                return (
                    <Error500
                        errorMessage={usersFetchError?.response?.statusText}
                        errorData={usersFetchError?.response?.data?.error}
                    />
                );
        }
    };

    return <StyledPanelContainer>{renderUsersAdminPanel()}</StyledPanelContainer>;
};

export default UsersAdmin;
